import { env } from 'config'
import { PersistentSnackbarStack } from './PersistentSnackbar'
import PasswordPolicySnackbar from './PasswordPolicySnackbar'
import TwoFactorPromptSnackbar from './TwoFactorPromptSnackbar'

const SecuritySnackbars = () => (
  <PersistentSnackbarStack>
    {!env.hideTwoFactorAuth && <TwoFactorPromptSnackbar />}
    <PasswordPolicySnackbar />
  </PersistentSnackbarStack>
)

export default SecuritySnackbars
